var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"breakdance-alert-box",class:`breakdance-alert-box--${_vm.alertClass}`,attrs:{"icon":false,"dense":"","border":"left","text":"","type":_vm.alertType}},[_c('div',{staticClass:"breakdance-alert-box__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }